import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import PageTitle from 'hoc/PageTitle';
import AnnotationsTableContainer from 'containers/tables/AnnotationsTableContainer';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const ListAnnotationsPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer title="Annotations" admin hideDatePicker />}>

        <AnnotationsTableContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Annotations' }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(ListAnnotationsPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/annotations/ListAnnotations.js